import Rails from '@rails/ujs';
Rails.start();

import Turbolinks from 'turbolinks';
Turbolinks.start();

import './global-jquery';
import 'bootstrap';
import 'bootstrap-tab-history';

import './features/companyForm';
import './features/orders';
import './features/signIn';
import './features/validation';
import './overrides';
